<template>
  <div class="missing-page">
    <div class="missing-page-container">
      <div class="missing-page-content">
        <img class="image" src="https://s3-us-west-2.amazonaws.com/staging-backoffice/staging/404.jpg" />
        <div class="title">Oh no!</div>
        <div class="content">
          <span>There's nothing here for you.. and you're all alone</span>
          <i class="far fa-frown"></i>
        </div>
        <div class="instructions">
          Why don't you head back to the <a href="#/dispatch">home page</a>.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'missing-page',
  mounted () {
    this.$store.commit('sideMenu/hide')
    this.$store.commit('sideMenu/hideMenuButton')
  },
  destroyed () {
    this.$store.commit('sideMenu/showMenuButton')
  }
}
</script>

<style lang="scss" scoped>
.missing-page{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #fefefe;
  text-align: center;
}

.missing-page-container{
  display: table;
  width: 100%;
  height: 100%;
}

.missing-page-content{
  display: table-cell;
  vertical-align: middle;
}

.image{
  margin-bottom: 10px;
}

.title{
  font-size: 36px;
  font-weight: 700;
  color: #3F2975;
  margin-bottom: 15px;
}

.content{
  font-size: 20px;
  font-weight: 700;
  color: #555555;
  margin-bottom: 5px;
}

.instructions{
  color: #555;
  font-size: 16px;

  & a{
    color: #3F2975;
    font-weight: 700;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Error/404.vue